<template>
  <div v-if="store.active" class="hw-decor" aria-hidden="true" data-testid="halloween-decor">
    <template v-if="store.isEggEnabled('bats')">
      <div v-for="n in 3" :key="n" class="hw-bat" :class="`hw-bat--${n}`" data-testid="halloween-bat">
        <svg class="hw-bat__flyer" viewBox="0 0 44 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            class="hw-bat__wing hw-bat__wing--left"
            d="M19 11C16 6 11 3 6 3 3 3 0 4.4 0 4.4s3.6 1.1 4.4 4.5C2 9.2 0 11 0 11s3.2.2 5 2.6C3.4 14.5 2.5 17 2.5 17s3.9-2 7.3-1c2.6.8 4.7 3.3 6.7 5.6L19 15z"
          />
          <path
            class="hw-bat__wing hw-bat__wing--right"
            d="M25 11c3-5 8-8 13-8 3 0 6 1.4 6 1.4s-3.6 1.1-4.4 4.5C42 9.2 44 11 44 11s-3.2.2-5 2.6c1.6.9 2.5 3.4 2.5 3.4s-3.9-2-7.3-1c-2.6.8-4.7 3.3-6.7 5.6L25 15z"
          />
          <path
            d="M22 5.5c-1.9 0-3.5 1.6-3.5 3.6v8.4c0 2.5 1.6 4.5 3.5 4.5s3.5-2 3.5-4.5V9.1c0-2-1.6-3.6-3.5-3.6zM19.2 7.2 18 3.4l3 2.5zm5.6 0 1.2-3.8-3 2.5z"
          />
        </svg>
      </div>
    </template>

    <div v-if="store.isEggEnabled('storm') && lightning" class="hw-storm" data-testid="halloween-lightning">
      <div class="hw-storm__flash" />
      <svg class="hw-storm__bolt" :style="boltStyle" viewBox="0 0 60 220" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M34 0 10 92h18L14 220l40-140H32z"
          fill="#f3eeff"
          stroke="#c4b5fd"
          stroke-width="2"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div v-if="store.isEggEnabled('cobwebs') || store.isEggEnabled('spider')" class="hw-corner">
      <div class="hw-corner__web">
        <svg
          v-if="store.isEggEnabled('cobwebs')"
          class="hw-cobweb"
          viewBox="0 0 160 160"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          xmlns="http://www.w3.org/2000/svg"
          data-testid="halloween-cobweb"
        >
          <path
            d="M156 154.5L154.2 160M81.2 127.4L77.6 160M39.6 75.4L0 79.5M11.2 5.3L0 11.2"
            stroke-width="0.9"
            opacity="0.8"
          />
          <path
            d="M160 0Q158.8 85 156 154.5M160 0Q146.3 77.4 134.1 140.6M160 0Q131.1 78.3 106.7 142.1M160 0Q115.3 69.3 81.2 127.4M160 0Q109.7 64.7 67.1 116.6M160 0Q94.1 59.9 38.8 107.4M160 0Q93.7 41.2 39.6 75.4M160 0Q87.8 27.5 28.9 50.3M160 0Q73.7 18.9 3.7 37.3M160 0Q78.1 1.7 11.2 5.3"
            stroke-width="0.9"
          />
          <path
            class="hw-cobweb__spiral"
            d="M159.5 19.2Q158.1 18.2 156.2 20.8Q154.9 18.3 152.2 20.7Q151.3 17.7 148.2 19.1Q148.3 16.7 145.9 17.6Q145.5 15.3 141.9 16.1Q142.6 13 138.9 13.2Q140 10 136.9 8.9Q138 6.8 134.5 6.1Q136.5 3.2 133.7 0.9M159.3 26.8Q157.4 25 154.9 27.5Q153.1 24.8 149.9 26.9Q148.3 23.7 144.4 25.2Q144.4 22.2 140.8 24Q140.9 20.2 136.2 21.1Q137.2 17.1 132.3 17.4Q133.9 13 128.7 12Q131.5 8.8 126.6 8Q129.8 4.1 125.3 1.2M159.1 34.7Q156.7 31.7 153.6 34.6Q151.3 31.3 147.1 34.4Q145.4 29.8 140.4 31.7Q140.5 27.7 136.1 29.9Q136.2 25.1 131.5 25.3Q131.8 21.1 126.9 20.7Q127.9 16 121.8 14.6Q125.1 10.8 120 9.5Q123.1 5 118 1.5M158.9 41.8Q156 38.4 152.2 42.4Q149.5 37.8 144.3 41.8Q142.4 35.8 136.3 38.3Q136.6 33.2 131.2 36.2Q131.6 29.9 125.8 30.4Q126.4 25.1 120.2 24.9Q121.8 19 115 17.3Q118.6 12.8 112.9 11.2Q116.4 5.9 110.3 1.8M158.7 50.1Q155.3 45.1 150.9 49.3Q147.7 44.3 142.1 47.6Q139.4 41.9 132.1 45.1Q132.7 38.7 127.3 41Q126.9 34.8 120.1 35.3Q121 29.2 114 28.8Q115.8 22.1 108.1 19.9Q112.2 14.8 105 13.1Q109.7 6.8 103.3 2M158.5 57.5Q154.6 51.8 149.4 57.7Q145.9 50.8 139.4 54.9Q136.4 48 128.7 50.6Q128.9 44.2 122.2 47.5Q121 41.1 114 40.8Q114.1 34.3 108.1 32.5Q108.1 25.9 102 22.2Q103.9 17.4 98.8 14.6Q101.1 8 95.4 2.3M158.3 65.3Q153.7 60.5 147.9 65.4Q143.6 59.3 136.5 62.7Q132.6 55.8 124.8 56.9Q123.8 51.4 117.4 53.5Q116.2 46.1 108 46.1Q108.5 38.5 101.3 36.8Q101.9 29 95.1 24.9Q97.3 19.4 91.1 16.4Q94.2 8.9 88.6 2.5M158.1 72Q152.9 67.4 146.8 71.3Q141.7 66 134.2 68.7Q129.5 62.1 120.4 64.1Q119.8 57.1 113.4 58.5Q111.4 51.2 102.8 50.7Q102.9 42.7 95.2 40.6Q95.6 32.1 87.9 27.6Q90.6 21.5 83.1 18.3Q87.3 9.9 81.1 2.8M157.9 79.5Q152.2 74.3 145.4 79.3Q139.8 72.7 131.3 76.6Q126.4 68.3 116.7 70Q115.8 62.8 107.9 65.4Q106.6 56.2 97.4 55.4Q97.4 46.9 88.4 44.9Q89.4 35.2 80.1 30.6Q83.9 23.5 76.4 19.9Q80.4 10.8 73 3.1M157.7 87.4Q151.5 81.3 144.1 86.2Q138 79.4 128.9 82.8Q123.4 74.6 112.6 76.7Q111.8 68.5 103.4 71.1Q101.8 61.3 91.2 61Q91.8 51.1 81.8 49Q83.1 38.4 73.3 33.2Q77.3 25.6 69.6 21.6Q73.5 11.7 65.2 3.4M157.5 94.4Q150.8 88.2 142.7 94Q136.1 86.1 126.3 89.8Q120.3 80.9 108.9 82.5Q107.7 74.2 99.1 76.4Q97 66.4 86.2 65.4Q86.2 55.2 75.4 53Q76.9 41.5 66.3 35.9Q70.6 27.7 62.2 23.3Q66.6 12.7 57.9 3.6M157.3 102.8Q150 95.2 141.2 102.1Q134.2 92.9 123.7 96.7Q117.2 87.1 104.8 89.2Q103.7 79.9 93.9 83Q92.2 71.4 80.8 70.2Q80.6 59.4 69.7 56.6Q70.6 44.6 58.9 38.7Q63.9 29.7 54.7 25.1Q59.7 13.6 51 3.9M157.1 110.5Q149.3 102.1 139.9 108.7Q132.4 99.6 121 103.9Q114.1 93.4 101.2 95.1Q99.7 85.6 89.7 88.2Q87.4 76.5 74.6 75.7Q75 63.6 63.2 60.7Q64.4 47.7 52 41.4Q57.3 31.8 47.8 26.7Q52.8 14.5 43.7 4.1M156.9 117.7Q148.6 109 138.6 116.3Q130.5 106.3 118.2 111.4Q111.1 99.7 96.6 102.4Q95.7 91.4 85.1 94Q82.6 81.5 69.6 80.1Q69.4 67.8 57.3 64.4Q58.2 50.8 45.4 43.9Q50.6 33.8 40.2 28.6Q45.8 15.5 35.9 4.4M156.7 124.2Q147.9 116 137.3 122.9Q128.6 113 115.6 118.3Q108 105.9 92.8 108.6Q91.7 97.1 80.4 99.8Q77.8 86.6 63.2 85.8Q63.9 72 50.2 68.8Q51.9 53.9 38.5 46.6Q43.9 35.9 32.1 30.5Q38.9 16.4 28.8 4.7M156.5 132.6Q147.1 122.9 135.7 131.6Q126.8 119.7 112.9 125.5Q104.9 112.2 89.3 114.4Q87.7 102.8 76 105.5Q73 91.7 57.9 90.5Q58.3 76.1 44.3 72.5Q45.7 57 31.6 49.2Q37.3 38 25.2 32.1Q32 17.4 20.1 5M156.3 140.2Q146.4 129.8 134.5 138.4Q124.9 126.5 110.1 133Q101.8 118.4 85.3 120.7Q83.6 108.5 71 111.7Q68.2 96.7 52.2 95.5Q52.7 80.3 37.5 76.8Q39.4 60.2 24.8 51.8Q30.6 40 18.1 33.8Q25.1 18.3 12.8 5.2M156.1 147Q145.7 136.8 133.1 146.1Q123 133.2 107.9 138.8Q98.8 124.7 80.8 128Q79.6 114.2 66 117.9Q63.4 101.8 47 100.1Q47.1 84.5 30.5 81.1Q33.2 63.3 16.9 54.8Q24 42.1 11.4 35.4Q18.2 19.2 6.2 5.5"
            stroke-width="0.6"
          />
          <path
            d="M159.9 3L159.4 3.2L158.8 3.2L158.1 3.1L157.6 3L156.9 2.7L156.3 2.3L155.8 1.6L155.4 1.1L155 0.2M159.9 5.2L159 5.3L158 5.3L156.9 5L156.2 4.8L155.3 4.2L154.5 3.5L153.7 2.4L153.2 1.6L152.8 0.3M159.8 7.4L158.6 7.5L157.2 7.3L155.8 6.9L154.8 6.5L153.6 5.6L152.6 4.6L151.7 3.2L151.1 2.1L150.6 0.3M159.7 9.6L158.2 9.7L156.5 9.4L154.6 8.7L153.5 8.2L152 7.1L150.7 5.8L149.6 4L148.9 2.6L148.4 0.4M159.7 11.8L157.8 11.8L155.7 11.5L153.4 10.6L152.1 9.9L150.3 8.6L148.9 7L147.5 4.8L146.8 3.1L146.2 0.5M159.6 14L157.4 14L154.9 13.5L152.3 12.5L150.7 11.6L148.7 10L147 8.1L145.5 5.6L144.7 3.7L144 0.6"
            stroke-width="0.55"
            opacity="0.9"
          />
          <path
            d="M47.5 26.8Q46.4 31.8 47 37.4M137.1 124Q137.4 129 134.9 135.1M134.9 66.8Q134.8 71.8 137.3 75.5"
            stroke-width="0.5"
            opacity="0.7"
          />
          <g opacity="0.9">
            <circle cx="38.4" cy="46.6" r="1.1" fill="currentColor" />
            <circle cx="114.2" cy="40.6" r="0.9" fill="currentColor" />
            <circle cx="142.6" cy="94.2" r="1.2" fill="currentColor" />
            <circle cx="157.1" cy="110" r="1" fill="currentColor" />
            <circle cx="74.9" cy="75.4" r="1" fill="currentColor" />
            <circle cx="107.5" cy="32.9" r="1.3" fill="currentColor" />
            <circle cx="115.4" cy="17.1" r="1.2" fill="currentColor" />
            <circle cx="75.7" cy="52.8" r="1.2" fill="currentColor" />
            <circle cx="115.6" cy="118.4" r="1.2" fill="currentColor" />
          </g>
        </svg>
        <svg
          v-if="store.isEggEnabled('spider') && spiderState !== SpiderState.GONE"
          class="hw-spider"
          :class="spiderClasses"
          :style="spiderStyle"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          data-testid="halloween-spider"
          @click="botherSpider"
        >
          <g
            class="hw-spider__legs hw-spider__legs--left"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          >
            <path d="M11 14 4 8M11 16 3 15M11 18 4 23M12 20 8 27" />
          </g>
          <g
            class="hw-spider__legs hw-spider__legs--right"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linecap="round"
          >
            <path d="M19 14l7-6M19 16l8-1M19 18l7 5M18 20l4 7" />
          </g>
          <circle cx="15" cy="10" r="3.2" fill="currentColor" />
          <ellipse cx="15" cy="18" rx="5" ry="6.5" fill="currentColor" />
          <circle cx="13.8" cy="9.4" r="0.7" fill="#ffffff" />
          <circle cx="16.2" cy="9.4" r="0.7" fill="#ffffff" />
        </svg>
      </div>
    </div>

    <div v-if="eyesOut" class="hw-eyes" data-testid="halloween-eyes">
      <div class="hw-eyes__dark" />
      <div v-for="pair in eyePairs" :key="pair.id" class="hw-eyes__pair" :style="pair.style">
        <span class="hw-eyes__eye" />
        <span class="hw-eyes__eye" />
      </div>
    </div>

    <div v-if="booing" class="hw-scare" data-testid="halloween-ghost">
      <div class="hw-scare__dark" />
      <div class="hw-scare__flash" />
      <div class="hw-scare__stage">
        <svg class="hw-scare__box hw-scare__box--back" viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg">
          <path d="M28 84h184v110H28z" fill="#1a1208" />
          <path class="hw-scare__lid hw-scare__lid--back" d="M28 84l14-36h156l14 36z" fill="#a9763f" />
        </svg>
        <span class="hw-scare__glow" />
        <span class="hw-scare__smoke hw-scare__smoke--1" />
        <span class="hw-scare__smoke hw-scare__smoke--2" />
        <span class="hw-scare__smoke hw-scare__smoke--3" />
        <div class="hw-scare__hand hw-scare__hand--left">
          <svg viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 50V22c0-5 4-8 9-8h6c5 0 9 3 9 8v8H14z" fill="#6f7d6c" />
            <g class="hw-hand__fingers">
              <path d="M18 22l-4-14M25 20l-1-16M32 22l3-15" stroke="#6f7d6c" stroke-width="5" stroke-linecap="round" />
              <path d="M14 8l-3-6M24 4l0-4M35 7l3-6" stroke="#e9e4d6" stroke-width="2.6" stroke-linecap="round" />
            </g>
          </svg>
        </div>
        <div class="hw-scare__hand hw-scare__hand--right">
          <svg viewBox="0 0 40 50" xmlns="http://www.w3.org/2000/svg" style="transform: scaleX(-1)">
            <path d="M14 50V22c0-5 4-8 9-8h6c5 0 9 3 9 8v8H14z" fill="#6f7d6c" />
            <g class="hw-hand__fingers">
              <path d="M18 22l-4-14M25 20l-1-16M32 22l3-15" stroke="#6f7d6c" stroke-width="5" stroke-linecap="round" />
              <path d="M14 8l-3-6M24 4l0-4M35 7l3-6" stroke="#e9e4d6" stroke-width="2.6" stroke-linecap="round" />
            </g>
          </svg>
        </div>
        <div class="hw-scare__mon hw-scare__mon--ghoul">
          <svg viewBox="0 0 80 112" xmlns="http://www.w3.org/2000/svg">
            <g class="hw-mon__leg hw-mon__leg--l">
              <path d="M32 80l-3 22" stroke="#5c6b5d" stroke-width="9" stroke-linecap="round" />
              <path d="M22 104h14l-2-4h-10z" fill="#3f4a40" />
            </g>
            <g class="hw-mon__leg hw-mon__leg--r">
              <path d="M48 80l3 22" stroke="#5c6b5d" stroke-width="9" stroke-linecap="round" />
              <path d="M44 104h14l-2-4h-10z" fill="#3f4a40" />
            </g>
            <path d="M22 40c0-15 8-26 18-26s18 11 18 26l-5 3c0-11-6-20-13-20s-13 9-13 20z" fill="#341278" />
            <g class="hw-mon__torso">
              <path d="M22 42c-5 12-5 26 0 40h36c5-14 5-28 0-40z" fill="#6f7d6c" />
              <path d="M18 42c0-7 9-12 22-12s22 5 22 12l3 30-6-3-5 6-6-5-6 6-6-5-5 5-6-5-4 4z" fill="#44179d" />
              <path d="M23 44c3-2 7-3 17-3s14 1 17 3" fill="none" stroke="#2a0f63" stroke-width="2" />
              <g transform="translate(29 48) scale(1.5)" fill="#ffffff">
                <path
                  d="M7.68626 8.68484L6.35563 7.67335L5.88281 8.25907L7.75212 9.70497L11.3857 5.19165L10.4753 5.125L7.68626 8.68484Z"
                />
                <path
                  d="M10.3804 7.56712C9.95309 9.03497 9.04745 10.2229 7.63606 11.1615C6.71159 10.6544 5.96107 9.88098 5.48212 8.94166C5.04616 8.09326 4.78583 7.04883 4.70585 5.82876C5.71725 5.69101 6.71075 5.44415 7.66899 5.09248C8.17396 5.28801 8.69033 5.45272 9.21525 5.58568L9.70845 4.9584C9.01261 4.80151 8.33117 4.58643 7.67134 4.31543C6.55086 4.76786 5.30569 5.05327 3.95703 5.19206C4.00016 8.29085 5.02812 10.7051 7.67134 11.9997C9.8049 10.7051 11.0924 8.86795 11.3433 6.3643L10.3804 7.56712Z"
                />
              </g>
              <path d="M30 70l4 3M36 72l2 3M48 69l-3 4" stroke="#2b2f2a" stroke-width="1.5" stroke-linecap="round" />
            </g>
            <g class="hw-mon__pose hw-mon__pose--climb">
              <path d="M24 44L17 24" stroke="#6f7d6c" stroke-width="8" stroke-linecap="round" />
              <path d="M17 24L15 6" stroke="#5c6b5d" stroke-width="7" stroke-linecap="round" />
              <circle cx="15" cy="4" r="5" fill="#5c6b5d" />
              <path d="M11 3l-3-6M15 1v-7M19 3l3-6" stroke="#e9e4d6" stroke-width="2.4" stroke-linecap="round" />
              <path d="M56 44L63 24" stroke="#6f7d6c" stroke-width="8" stroke-linecap="round" />
              <path d="M63 24L65 6" stroke="#5c6b5d" stroke-width="7" stroke-linecap="round" />
              <circle cx="65" cy="4" r="5" fill="#5c6b5d" />
              <path d="M61 3l-3-6M65 1v-7M69 3l3-6" stroke="#e9e4d6" stroke-width="2.4" stroke-linecap="round" />
            </g>
            <g class="hw-mon__pose hw-mon__pose--run">
              <g class="hw-mon__arm hw-mon__arm--l">
                <path d="M24 44l-10 20" stroke="#6f7d6c" stroke-width="8" stroke-linecap="round" />
                <path d="M14 64l-4 20" stroke="#5c6b5d" stroke-width="7" stroke-linecap="round" />
                <g transform="translate(6 82) scale(-1 1)">
                  <g class="hw-mon__claw">
                    <path d="M0 0c-3 0-5 2-5 5s2 5 5 5h4c3 0 5-2 5-5S7 0 4 0z" fill="#5c6b5d" />
                    <path
                      class="hw-mon__finger"
                      d="M-1 9l-3 8M3 10l-1 9M7 9l2 8"
                      stroke="#e9e4d6"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    />
                  </g>
                </g>
              </g>
              <g class="hw-mon__arm hw-mon__arm--r">
                <path d="M56 44l10 20" stroke="#6f7d6c" stroke-width="8" stroke-linecap="round" />
                <path d="M66 64l4 20" stroke="#5c6b5d" stroke-width="7" stroke-linecap="round" />
                <g transform="translate(66 82) scale(1 1)">
                  <g class="hw-mon__claw">
                    <path d="M0 0c-3 0-5 2-5 5s2 5 5 5h4c3 0 5-2 5-5S7 0 4 0z" fill="#5c6b5d" />
                    <path
                      class="hw-mon__finger"
                      d="M-1 9l-3 8M3 10l-1 9M7 9l2 8"
                      stroke="#e9e4d6"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g class="hw-mon__head">
              <path d="M26 12l-7-10 3 12zM54 12l7-10-3 12z" fill="#4a4f45" />
              <path d="M40 4c-12 0-19 9-19 19 0 8 4 14 9 17h20c5-3 9-9 9-17 0-10-7-19-19-19z" fill="#9aa58f" />
              <path d="M24 26c2 6 6 10 10 12h12c4-2 8-6 10-12-4 3-9 4-16 4s-12-1-16-4z" fill="#7d8877" />
              <ellipse cx="32" cy="22" rx="5" ry="6" fill="#1b1f27" />
              <ellipse cx="48" cy="22" rx="5" ry="6" fill="#1b1f27" />
              <circle class="hw-mon__eye" cx="32" cy="23" r="2" fill="#f28c28" />
              <circle class="hw-mon__eye" cx="48" cy="23" r="2" fill="#f28c28" />
              <path d="M40 27l-2 5h4z" fill="#1b1f27" />
              <g class="hw-mon__jaw">
                <path d="M28 36c2 5 6 8 12 8s10-3 12-8z" fill="#2b2f2a" />
                <path
                  d="M31 36l1 4M35 36l1 5M40 36v5M45 36l-1 5M49 36l-1 4"
                  stroke="#f3f1ea"
                  stroke-width="1.6"
                  stroke-linecap="round"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="hw-scare__mon hw-scare__mon--zombie">
          <svg viewBox="0 0 80 112" xmlns="http://www.w3.org/2000/svg">
            <g class="hw-mon__leg hw-mon__leg--l">
              <path d="M31 80l-2 22" stroke="#4a4f45" stroke-width="10" stroke-linecap="round" />
              <path d="M22 104h14l-1-4h-11z" fill="#2b2f2a" />
            </g>
            <g class="hw-mon__leg hw-mon__leg--r">
              <path d="M49 80l4 22" stroke="#4a4f45" stroke-width="10" stroke-linecap="round" />
              <path d="M46 104h14l-2-4h-10z" fill="#2b2f2a" />
            </g>
            <g class="hw-mon__torso">
              <path d="M22 42c-4 12-4 26 0 40h36c4-14 4-28 0-40z" fill="#7f9a6a" />
              <path d="M20 42h40l2 24-5-2-4 5-5-4-5 5-5-4-5 5-5-4-6 3z" fill="#5b1fd3" />
              <path d="M46 50c4 2 8 2 11 1l1 10c-4 1-9 0-13-3z" fill="#7f9a6a" />
              <path d="M48 52h8M48 56h9M49 60h8" stroke="#e9e4d6" stroke-width="1.6" stroke-linecap="round" />
              <g transform="translate(24 46) scale(1.5)" fill="#ffffff">
                <path
                  d="M7.68626 8.68484L6.35563 7.67335L5.88281 8.25907L7.75212 9.70497L11.3857 5.19165L10.4753 5.125L7.68626 8.68484Z"
                />
                <path
                  d="M10.3804 7.56712C9.95309 9.03497 9.04745 10.2229 7.63606 11.1615C6.71159 10.6544 5.96107 9.88098 5.48212 8.94166C5.04616 8.09326 4.78583 7.04883 4.70585 5.82876C5.71725 5.69101 6.71075 5.44415 7.66899 5.09248C8.17396 5.28801 8.69033 5.45272 9.21525 5.58568L9.70845 4.9584C9.01261 4.80151 8.33117 4.58643 7.67134 4.31543C6.55086 4.76786 5.30569 5.05327 3.95703 5.19206C4.00016 8.29085 5.02812 10.7051 7.67134 11.9997C9.8049 10.7051 11.0924 8.86795 11.3433 6.3643L10.3804 7.56712Z"
                />
              </g>
              <path d="M28 72l3 4M50 70l-2 5" stroke="#3a4a30" stroke-width="1.5" stroke-linecap="round" />
            </g>
            <g class="hw-mon__pose hw-mon__pose--climb">
              <path d="M24 44L17 24" stroke="#7f9a6a" stroke-width="8" stroke-linecap="round" />
              <path d="M17 24L15 6" stroke="#6d8a58" stroke-width="7" stroke-linecap="round" />
              <circle cx="15" cy="4" r="5" fill="#6d8a58" />
              <path d="M11 3l-3-6M15 1v-7M19 3l3-6" stroke="#e9e4d6" stroke-width="2.4" stroke-linecap="round" />
              <path d="M56 44L63 24" stroke="#7f9a6a" stroke-width="8" stroke-linecap="round" />
              <path d="M63 24L65 6" stroke="#6d8a58" stroke-width="7" stroke-linecap="round" />
              <circle cx="65" cy="4" r="5" fill="#6d8a58" />
              <path d="M61 3l-3-6M65 1v-7M69 3l3-6" stroke="#e9e4d6" stroke-width="2.4" stroke-linecap="round" />
            </g>
            <g class="hw-mon__pose hw-mon__pose--run">
              <g class="hw-mon__arm hw-mon__arm--l">
                <path d="M24 44l-12 14" stroke="#7f9a6a" stroke-width="8" stroke-linecap="round" />
                <path d="M12 58l-2 22" stroke="#6d8a58" stroke-width="7" stroke-linecap="round" />
                <g transform="translate(6 78) scale(-1 1)">
                  <g class="hw-mon__claw">
                    <path d="M0 0c-3 0-5 2-5 5s2 5 5 5h4c3 0 5-2 5-5S7 0 4 0z" fill="#5c6b5d" />
                    <path
                      class="hw-mon__finger"
                      d="M-1 9l-3 8M3 10l-1 9M7 9l2 8"
                      stroke="#e9e4d6"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    />
                  </g>
                </g>
              </g>
              <g class="hw-mon__arm hw-mon__arm--r hw-mon__arm--hang">
                <path d="M56 44l8 18" stroke="#7f9a6a" stroke-width="8" stroke-linecap="round" />
                <path d="M64 62l-2 22" stroke="#6d8a58" stroke-width="7" stroke-linecap="round" />
                <g transform="translate(58 82) scale(1 1)">
                  <g class="hw-mon__claw">
                    <path d="M0 0c-3 0-5 2-5 5s2 5 5 5h4c3 0 5-2 5-5S7 0 4 0z" fill="#5c6b5d" />
                    <path
                      class="hw-mon__finger"
                      d="M-1 9l-3 8M3 10l-1 9M7 9l2 8"
                      stroke="#e9e4d6"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g class="hw-mon__head">
              <path d="M40 6c-11 0-18 8-18 18 0 7 3 12 7 15h22c4-3 7-8 7-15 0-10-7-18-18-18z" fill="#8fa878" />
              <path d="M22 18c3-6 9-10 18-10s15 4 18 10c-4-3-10-4-18-4s-14 1-18 4z" fill="#3a2e24" />
              <path d="M28 10l-2-8 5 7zM50 9l4-7-1 8z" fill="#3a2e24" />
              <circle cx="31" cy="23" r="5.5" fill="#f3f1ea" />
              <circle class="hw-mon__eye" cx="32" cy="24" r="2.4" fill="#f28c28" />
              <path d="M43 21c2-2 6-2 8 0-1 2-2 3-4 3s-3-1-4-3z" fill="#1b1f27" />
              <path d="M24 27c2 2 4 3 6 3" fill="none" stroke="#5b7a48" stroke-width="1.5" />
              <path d="M46 30l3 3M49 28l4 1" stroke="#5b7a48" stroke-width="1.5" stroke-linecap="round" />
              <g class="hw-mon__jaw">
                <path d="M28 37c2 6 6 9 12 9s10-3 12-9c-4 2-8 3-12 3s-8-1-12-3z" fill="#2b2f2a" />
                <path d="M32 38v4M37 39v5M42 39v5M47 38v4" stroke="#f3f1ea" stroke-width="1.8" stroke-linecap="round" />
              </g>
            </g>
          </svg>
        </div>
        <div class="hw-scare__mon hw-scare__mon--wolf">
          <svg viewBox="0 0 80 112" xmlns="http://www.w3.org/2000/svg">
            <g class="hw-mon__leg hw-mon__leg--l">
              <path
                d="M30 78l-6 10 2 14"
                fill="none"
                stroke="#3b2a1e"
                stroke-width="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M20 102l-3 5M26 103v6M31 101l3 5" stroke="#e9e4d6" stroke-width="2.2" stroke-linecap="round" />
            </g>
            <g class="hw-mon__leg hw-mon__leg--r">
              <path
                d="M50 78l6 10-2 14"
                fill="none"
                stroke="#3b2a1e"
                stroke-width="10"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path d="M48 101l-3 5M54 103v6M59 102l3 5" stroke="#e9e4d6" stroke-width="2.2" stroke-linecap="round" />
            </g>
            <g class="hw-mon__torso">
              <path d="M18 44l6-6 4 6 5-7 4 7 3-8 4 8 3-7 5 7 4-6 6 6-2 38H20z" fill="#3b2a1e" />
              <path d="M28 52c4 8 6 16 6 26h12c0-10 2-18 6-26-3 3-7 4-12 4s-9-1-12-4z" fill="#5a4030" />
              <path
                d="M22 60l-4 3M58 60l4 3M24 72l-4 2M56 72l4 2"
                stroke="#3b2a1e"
                stroke-width="3"
                stroke-linecap="round"
              />
            </g>
            <g class="hw-mon__pose hw-mon__pose--climb">
              <path d="M22 44L15 24" stroke="#3b2a1e" stroke-width="10" stroke-linecap="round" />
              <path d="M15 24L13 6" stroke="#3b2a1e" stroke-width="9" stroke-linecap="round" />
              <circle cx="13" cy="4" r="5" fill="#3b2a1e" />
              <path d="M9 3l-3-6M13 1v-7M17 3l3-6" stroke="#e9e4d6" stroke-width="2.4" stroke-linecap="round" />
              <path d="M58 44L65 24" stroke="#3b2a1e" stroke-width="10" stroke-linecap="round" />
              <path d="M65 24L67 6" stroke="#3b2a1e" stroke-width="9" stroke-linecap="round" />
              <circle cx="67" cy="4" r="5" fill="#3b2a1e" />
              <path d="M63 3l-3-6M67 1v-7M71 3l3-6" stroke="#e9e4d6" stroke-width="2.4" stroke-linecap="round" />
            </g>
            <g class="hw-mon__pose hw-mon__pose--run">
              <g class="hw-mon__arm hw-mon__arm--l">
                <path d="M22 46l-12 16" stroke="#3b2a1e" stroke-width="10" stroke-linecap="round" />
                <path d="M10 62l-2 20" stroke="#3b2a1e" stroke-width="9" stroke-linecap="round" />
                <path d="M3 84l-4 8M8 86l-1 9M13 84l3 8" stroke="#e9e4d6" stroke-width="2.6" stroke-linecap="round" />
              </g>
              <g class="hw-mon__arm hw-mon__arm--r">
                <path d="M58 46l12 16" stroke="#3b2a1e" stroke-width="10" stroke-linecap="round" />
                <path d="M70 62l2 20" stroke="#3b2a1e" stroke-width="9" stroke-linecap="round" />
                <path d="M67 84l-3 8M72 86l1 9M77 84l4 8" stroke="#e9e4d6" stroke-width="2.6" stroke-linecap="round" />
              </g>
            </g>
            <g class="hw-mon__head">
              <path d="M24 18l-6-16 12 10zM56 18l6-16-12 10z" fill="#3b2a1e" />
              <path d="M27 16l-2-8 6 6zM53 16l2-8-6 6z" fill="#8a5a3c" />
              <path
                d="M40 6c-12 0-20 8-20 18 0 6 3 10 7 13l-3 7 8-4h16l8 4-3-7c4-3 7-7 7-13 0-10-8-18-20-18z"
                fill="#4a3424"
              />
              <path d="M30 32c0 6 4 10 10 10s10-4 10-10c-3 2-6 3-10 3s-7-1-10-3z" fill="#2a1c12" />
              <ellipse cx="31" cy="22" rx="4.5" ry="3.5" fill="#ffd66b" />
              <ellipse cx="49" cy="22" rx="4.5" ry="3.5" fill="#ffd66b" />
              <ellipse class="hw-mon__eye" cx="31" cy="22" rx="1.4" ry="3" fill="#1b1f27" />
              <ellipse class="hw-mon__eye" cx="49" cy="22" rx="1.4" ry="3" fill="#1b1f27" />
              <path d="M25 16l6 3M55 16l-6 3" stroke="#2a1c12" stroke-width="2.5" stroke-linecap="round" />
              <path d="M36 30h8l-4 3z" fill="#1b1f27" />
              <g class="hw-mon__jaw">
                <path d="M30 36c2 6 5 10 10 10s8-4 10-10c-3 1-6 2-10 2s-7-1-10-2z" fill="#7a1f1f" />
                <path d="M32 36l2 7M48 36l-2 7" stroke="#f3f1ea" stroke-width="2.6" stroke-linecap="round" />
                <path d="M37 37l1 4M43 37l-1 4" stroke="#f3f1ea" stroke-width="1.6" stroke-linecap="round" />
              </g>
            </g>
          </svg>
        </div>
        <svg class="hw-scare__box hw-scare__box--front" viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 90h200v124H20z" fill="#c8945a" />
          <path d="M20 90h200v12H20z" fill="#a9763f" />
          <path d="M110 90h20v124h-20z" fill="#8b54f7" />
          <path d="M20 90l8-6h184l8 6z" fill="#b8844a" />
          <path class="hw-scare__lid hw-scare__lid--left" d="M20 90L4 54h112l4 36z" fill="#d9a56b" />
          <path class="hw-scare__lid hw-scare__lid--right" d="M220 90l16-36H124l-4 36z" fill="#d9a56b" />
          <circle cx="120" cy="160" r="30" fill="#5b1fd3" />
          <g transform="translate(94 135) scale(3.3)" fill="#ffffff">
            <path
              d="M7.68626 8.68484L6.35563 7.67335L5.88281 8.25907L7.75212 9.70497L11.3857 5.19165L10.4753 5.125L7.68626 8.68484Z"
            />
            <path
              d="M10.3804 7.56712C9.95309 9.03497 9.04745 10.2229 7.63606 11.1615C6.71159 10.6544 5.96107 9.88098 5.48212 8.94166C5.04616 8.09326 4.78583 7.04883 4.70585 5.82876C5.71725 5.69101 6.71075 5.44415 7.66899 5.09248C8.17396 5.28801 8.69033 5.45272 9.21525 5.58568L9.70845 4.9584C9.01261 4.80151 8.33117 4.58643 7.67134 4.31543C6.55086 4.76786 5.30569 5.05327 3.95703 5.19206C4.00016 8.29085 5.02812 10.7051 7.67134 11.9997C9.8049 10.7051 11.0924 8.86795 11.3433 6.3643L10.3804 7.56712Z"
            />
          </g>
          <path d="M34 106l10 12M196 106l-10 12" stroke="#8a5a2a" stroke-width="2" stroke-linecap="round" />
        </svg>
        <span class="hw-scare__dust hw-scare__dust--left" />
        <span class="hw-scare__dust hw-scare__dust--right" />
      </div>
      <div class="hw-scare__title">BOO!</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { HALLOWEEN_EGGS, useSeasonalThemeStore } from '~/store/seasonal-theme';
import { useToastStore } from '~/store/toast';

enum SpiderState {
  BOTHERED = 'bothered',
  CALM = 'calm',
  GONE = 'gone',
}

const BOO = 'boo';
const SCARE_DURATION_MS = 7600;
const TOAST_DURATION_MS = 5000;
const SPIDER_BOTHERED_MS = 550;
const SPIDER_FLEE_MS = 750;
const SPIDER_RETURN_MS = 25_000;
const SPIDER_REST_TRANSFORM = 'translate(127px, 40px) rotate(18deg)';
const TYPING_TAGS = ['INPUT', 'SELECT', 'TEXTAREA'];
const LIGHTNING_FIRST_MS = [8_000, 20_000] as const;
const LIGHTNING_INTERVAL_MS = [25_000, 60_000] as const;
const LIGHTNING_MS = 1400;
const BOLT_X_RANGE_VW = [25, 90] as const;
const SPOOKY_FONT_URL = 'https://fonts.googleapis.com/css2?family=Creepster&display=swap';
const EYES_CHANCE = 0.04;
const EYES_COOLDOWN_MS = 180_000;
const EYES_MS = 3200;
const EYES_PAIR_COUNT = 16;
const EYE_COLOURS = ['#f28c28', '#ffd66b', '#9bff6b', '#ff5c5c'];

type EyePair = { id: number; style: Record<string, string> };

const store = useSeasonalThemeStore();
const toastStore = useToastStore();

const booing = ref(false);
const spiderState = ref<SpiderState>(SpiderState.CALM);
const spiderFrom = ref(SPIDER_REST_TRANSFORM);
const lightning = ref(false);
const eyesOut = ref(false);
const eyePairs = ref<EyePair[]>([]);
let lastEyesAt = -Infinity;
let eyesTimer: ReturnType<typeof setTimeout> | undefined;
const boltX = ref(50);
let lightningTimer: ReturnType<typeof setTimeout> | undefined;
let lightningOffTimer: ReturnType<typeof setTimeout> | undefined;
let typed = '';
let scareTimer: ReturnType<typeof setTimeout> | undefined;
let spiderTimer: ReturnType<typeof setTimeout> | undefined;
let appliedClasses: string[] = [];

const spiderClasses = computed(() => ({
  'hw-spider--bothered': spiderState.value === SpiderState.BOTHERED,
}));
const spiderStyle = computed(() => ({ '--hw-spider-from': spiderFrom.value }));
const boltStyle = computed(() => ({ left: `${boltX.value}vw` }));

// The display face is only fetched while the theme is actually showing.
useHead({
  link: computed(() =>
    store.active && store.isEggEnabled('spookyFont') ? [{ href: SPOOKY_FONT_URL, rel: 'stylesheet' }] : [],
  ),
});

function between([min, max]: readonly [number, number]): number {
  return min + Math.random() * (max - min);
}

function makeEyePairs(): EyePair[] {
  return Array.from({ length: EYES_PAIR_COUNT }, (_, id) => ({
    id,
    style: {
      '--hw-eye-colour': EYE_COLOURS[Math.floor(Math.random() * EYE_COLOURS.length)],
      '--hw-eye-delay': `${Math.round(Math.random() * 900)}ms`,
      '--hw-eye-size': `${Math.round(between([8, 22]))}px`,
      left: `${Math.round(between([4, 94]))}vw`,
      top: `${Math.round(between([6, 92]))}vh`,
    },
  }));
}

// Any click has a small chance, no more than once per cooldown, of dimming the lights and waking the eyes.
function onClick(event: MouseEvent) {
  if (!store.isEggEnabled('eyes') || eyesOut.value || isTypingTarget(event.target)) return;
  if (Date.now() - lastEyesAt < EYES_COOLDOWN_MS || Math.random() > EYES_CHANCE) return;

  lastEyesAt = Date.now();
  eyePairs.value = makeEyePairs();
  eyesOut.value = true;
  eyesTimer = setTimeout(() => {
    eyesOut.value = false;
  }, EYES_MS);
}

function strike() {
  boltX.value = between(BOLT_X_RANGE_VW);
  lightning.value = true;
  clearTimeout(lightningOffTimer);
  lightningOffTimer = setTimeout(() => {
    lightning.value = false;
  }, LIGHTNING_MS);
}

function scheduleLightning(range: readonly [number, number]) {
  clearTimeout(lightningTimer);
  lightningTimer = setTimeout(() => {
    if (store.isEggEnabled('storm')) strike();
    scheduleLightning(LIGHTNING_INTERVAL_MS);
  }, between(range));
}

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;

  return target.isContentEditable || TYPING_TAGS.includes(target.tagName);
}

function scare() {
  clearTimeout(scareTimer);
  booing.value = false;
  nextTick(() => {
    booing.value = true;
  });
  scareTimer = setTimeout(() => {
    booing.value = false;
  }, SCARE_DURATION_MS);

  toastStore.addToast({
    message: 'Something is scratching at the glass. Happy Halloween from Order Protection.',
    timeout: TOAST_DURATION_MS,
    title: 'They know you are here.',
    type: 'warning',
  });
}

function onKeydown(event: KeyboardEvent) {
  if (!store.isEggEnabled('boo') || event.key.length !== 1 || isTypingTarget(event.target)) return;

  typed = (typed + event.key.toLowerCase()).slice(-BOO.length);

  if (typed !== BOO) return;

  typed = '';
  scare();
}

// A click rattles the spider where it stands, it bolts off the web from there, and it creeps back a while later.
function botherSpider(event: MouseEvent) {
  if (spiderState.value !== SpiderState.CALM) return;

  const current = event.currentTarget instanceof Element ? getComputedStyle(event.currentTarget).transform : '';

  spiderFrom.value = current && current !== 'none' ? current : SPIDER_REST_TRANSFORM;
  spiderState.value = SpiderState.BOTHERED;
  spiderTimer = setTimeout(() => {
    spiderState.value = SpiderState.GONE;
    spiderTimer = setTimeout(() => {
      spiderState.value = SpiderState.CALM;
    }, SPIDER_RETURN_MS);
  }, SPIDER_BOTHERED_MS + SPIDER_FLEE_MS);
}

function applyRootClasses(classes: string[]) {
  const root = document.documentElement;

  root.classList.remove(...appliedClasses);
  root.classList.add(...classes);
  appliedClasses = classes;
}

onMounted(() => {
  store.sync();
  watch(() => store.htmlClasses, applyRootClasses, { immediate: true });
  window.addEventListener('keydown', onKeydown);
  window.addEventListener('click', onClick);
  scheduleLightning(LIGHTNING_FIRST_MS);
});

onBeforeUnmount(() => {
  window.removeEventListener('keydown', onKeydown);
  window.removeEventListener('click', onClick);
  clearTimeout(eyesTimer);
  clearTimeout(scareTimer);
  clearTimeout(spiderTimer);
  clearTimeout(lightningTimer);
  clearTimeout(lightningOffTimer);
  applyRootClasses([]);
});

defineExpose({ eggs: HALLOWEEN_EGGS });
</script>
